import { render, staticRenderFns } from "./view-img.vue?vue&type=template&id=f4488d2e&scoped=true&"
import script from "./view-img.vue?vue&type=script&lang=js&"
export * from "./view-img.vue?vue&type=script&lang=js&"
import style0 from "./view-img.vue?vue&type=style&index=0&id=f4488d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4488d2e",
  null
  
)

export default component.exports